<div class="flex flex-col endpoint-card">
  <div class="endpoint-icon"></div>
  <div class="endpoint-divider"></div>
  <div class="mt-24 mat-headline-5">
    {{endpoint.name}}
  </div>
  <div class="mb-24">
    {{endpoint.description}}
  </div>
  <a class="flex flex-row items-center button accent" [href]="endpoint.url" target="_blank">
    <div class="mr-6">{{ 'BUTTONS.OPEN' | transloco }}</div>
    <mat-icon svgIcon="open_in_new" class="external-link-icon mb-8"></mat-icon>
  </a>
</div>

